var fn = function( obj ){
var __t,__p='';
__p+='precision highp float;\n\nattribute vec3 aPosition;\nattribute vec2 aOffset;\n\nvarying vec3 vPosition;\n\nvoid main() {\n    gl_Position = vec4(aOffset, 0.0, 1.0);\n    gl_PointSize = 1.0;\n    vPosition = aPosition;\n}\n';
return __p;
};
fn.toString=fn;
module.exports = fn;
/////////////

/////////////////////
///////////////////////
//////////////////////////////
 
////////////////////////////
///////////////////////////////////////
/////////////
///
 

/////////////////
/////////////////////////////////////////////////////////
/////////////////////////////////////////////////////
///////////////////////////////////////////////
////////////////////
///
//
////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////
///////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////////////

//////////
//
////////////////////////////////
////////////////////////////////////////////
///////
////
//////////////////////
//////////////////////////////////////////////////////////////////////////////////////////////////
////////
/////
///

/////////
fn.onHmr = function(){}
//////////
